import { z } from 'zod';

import { phoneRegex } from '#utils/phone.regex';

export const signupSchema = z.object({
  email: z.email({ error: 'Niepoprawny adres email' }).toLowerCase().trim(),
  phone: z.string().regex(phoneRegex, 'Niepoprawny numer telefonu').nullable(),
  birthdate: z
    .string()
    .nullable()
    .refine(
      (date) => {
        if (!date) return true;
        const birthDate = new Date(date);
        return birthDate < new Date();
      },
      { message: 'Data urodzenia musi być w przeszłości' }
    ),
  authToken: z.string().optional(),
});

export const signupSchemaParser = signupSchema.transform((data) => {
  return {
    ...data,
    phone: data.phone || null,
    birthdate: data.birthdate || null,
  };
});

export type SignupSchema = z.infer<typeof signupSchema>;
